import {FC, useEffect, useState} from "react";
import {ResultSearchContent} from "../../Sidebar/styles";
import IconToggleArrow from "../../../assets/icons/icon-toogle-arrow.svg";
import {IDataForSearchSidebar, ITypeRadar} from "../../../types";
import {colors} from "../../../mocks/projectsMock";
import CardItem from "../../CardItem";
import {SidebarTab} from "../../Sidebar";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../../../config/featureFlags";

interface IProps {
  searchDatasidebarInfo?: IDataForSearchSidebar;
  isShowTitleParams: boolean;
  id: string | number;
  name: string;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    clussterId?: number,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number,
    typeRadar?: ITypeRadar
  ) => void;
  typeRadar: ITypeRadar;
}

export const SidebarCardSearchDirectionItem: FC<IProps> = ({
  searchDatasidebarInfo,
  isShowTitleParams,
  id: directionId,
  name: directionName,
  openSidebarWithTab,
  typeRadar,
}) => {
  const [showDirectionsBlock, setShowDirectionsBlock] = useState(true);

  const [quantitiesItemsToShow, setQuantitiesItemsToShow] = useState(2);
  const handleShowMoreQuantitiesItem = () => {
    setQuantitiesItemsToShow((prev) => prev + 2);
  };
  const setColorTitle = (directionId: string | number) => {
    const segmentLabels =
      searchDatasidebarInfo?.directions &&
      searchDatasidebarInfo?.directions?.map((item) => item.id);
    const colorText = segmentLabels
      ?.map((item, i) => (item === directionId ? colors[i] : null))
      .find((item) => item !== null);
    return colorText ? colorText.back : "#fff";
  };
  const toggleDirectionsBlock = () => {
    setShowDirectionsBlock((prev) => !prev);
  };

  const resultFind = searchDatasidebarInfo?.clusters.filter(
    (itemCluster) => directionId === itemCluster.direction_id
  );

  useEffect(() => {
    setQuantitiesItemsToShow(2);
  }, [searchDatasidebarInfo]);

  const handleCardClick = (clusterId: number, clusterName: string) => {
    const directionTitle = searchDatasidebarInfo?.directions?.find(
      (item) => item.id === directionId
    )?.name;
    const segmentLabels =
      searchDatasidebarInfo?.directions &&
      searchDatasidebarInfo?.directions?.map((item) => {
        // if (typeRadar === "stateInitiative") return item.documentId;
        return item.id;
      });
    const color = segmentLabels
      ?.map((item, i) => (item === directionId ? colors[i] : null))
      .find((item) => item !== null);
    openSidebarWithTab(
      SidebarTab.CPU,
      directionId,
      clusterId,
      clusterName,
      directionTitle,
      color ?? undefined,
      undefined,
      undefined,
      typeRadar
    );
  };
  console.log("resultFind ", resultFind);
  return (
    <div style={{marginTop: 20}}>
      <div className="titleSearchItem" style={{}}>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: 10,
          }}
          onClick={toggleDirectionsBlock}
        >
          <div className="toggleArrowImg">
            <img
              src={IconToggleArrow}
              alt=""
              style={{
                rotate: `${showDirectionsBlock ? "0deg" : "180deg"}`,
                transition: "all 0.3s",
              }}
            />
          </div>
          <p
            style={{
              color: setColorTitle(directionId),
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            {directionName}
          </p>
        </div>
        <div
          style={{
            backgroundColor: "#4D525B",
            borderRadius: "20px",
            width: "auto",
            padding: "0 7px",
            color: "white",
            border: "1px solid ##22272B",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {resultFind?.length}
        </div>
      </div>
      {showDirectionsBlock && (
        <>
          {resultFind?.slice(0, quantitiesItemsToShow).map((item: any) => {
            console.log("item.battery_russia", item.battery_russia);
            return (
              <>
                <CardItem
                  key={item.id}
                  invest_volume_tier={item.invest_volume_tier}
                  market_volume_tier={item.market_volume_tier}
                  potential_volume_tier={item.potential_volume_tier}
                  title={item.name}
                  isFlashFilterEnabled={item.growth_potential}
                  isCritical={item.critical}
                  isNational={item.national}
                  isGpb={item.gpb}
                  type={SidebarTab.Clusters}
                  onClick={() => handleCardClick(item.id, item.name)}
                  imageCard={item.image.url}
                  isShowTitleParams={isShowTitleParams}
                  typeRadar={typeRadar}
                  batteryRussia={item.battery_russia}
                  batteryWorld={item.battery_world}
                  showBattery={FEATURE_CLUSTER_BATTERY_METRIC_ENABLED}
                />
              </>
            );
          })}
          {quantitiesItemsToShow < (resultFind?.length ?? 0) && (
            <span
              style={{
                color: "#0f9fff",
                padding: "5px 10px",
                cursor: "pointer",
              }}
              onClick={handleShowMoreQuantitiesItem}
            >
              Показать больше
            </span>
          )}
        </>
      )}
    </div>
  );
};
